import React from 'react';
import useAmplitude from 'utils/hooks/useAmplitude';
import useTranslation from 'utils/hooks/useTranslation';
import { useSelector } from 'react-redux';
import { Button, Typography } from 'antd';
import { ROUTE_INVOICES } from 'constants.js';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import styles from './styles.module.scss';

const ReplaceMonthlyStatementsBanner = () => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();
  const { creditAccountActivationDateTime } = useSelector(state => state.user.currentCorporation);
  const history = useHistory();

  const handlePageChange = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.invoicesAndStatementsPageClicked, {
      source: 'monthly statements page',
    });
    history.push(ROUTE_INVOICES);
  };

  const startingMonthWithNoMonthlyStatements = moment(creditAccountActivationDateTime)
    .add(1, 'month')
    .format('MMMM');

  return (
    <div className={styles.replaceMonthlyStatementsBannerContainer}>
      <section className={styles.replaceMonthlyStatementsBannerSection}>
        <Typography className={styles.replaceMonthlyStatementsBannerTitle}>
          {translateText('corporateAccounts.monthlyStatements.creditAccountBanner.title')}
        </Typography>
        <section className={styles.replaceMonthlyStatementsBannerDescription}>
          <Typography>
            {translateText('corporateAccounts.monthlyStatements.creditAccountBanner.description', {
              currentMonth: startingMonthWithNoMonthlyStatements,
            })}
          </Typography>
          <Button
            className={styles.replaceMonthlyStatementsBannerButton}
            onClick={handlePageChange}
          >
            {translateText(
              'corporateAccounts.monthlyStatements.creditAccountBanner.description.cta',
            )}
          </Button>
        </section>
      </section>
    </div>
  );
};

export default ReplaceMonthlyStatementsBanner;
